export const EXTERNAL_SYSTEMS = {
    VIDEO_CMS: 'Video CMS',
    ASSETS: 'Assets',
    BRIXWIRE: 'BrixWire',
    WOODWING_STUDIO: 'WoodWing Studio',
    OKTA: 'Okta',
    KORDIAM: 'Kordiam',
    TOOLBOX: 'Toolbox',
};

export const EXTERNAL_SYSTEM_NAMES = {
    bl: 'Bilan',
    bw: 'BrixWire',
    cs: 'WoodWing Studio',
    dn: 'Desknet',
    fw: 'Finanz Und Wirtschaft',
    ls: "L'Essentiel",
    nn: 'Newsnet',
    ti: 'Tamedia Interactive',
    tw: '20min',
    twa: '20min Automation',
    'dv-gz': 'Discovery-Gazette',
    'dv-tb': 'Discovery-Toolbox',
};

export const LEGACY_SYSTEM_NAMES = [
    EXTERNAL_SYSTEM_NAMES.bl,
    EXTERNAL_SYSTEM_NAMES.fw,
    EXTERNAL_SYSTEM_NAMES.ls,
    EXTERNAL_SYSTEM_NAMES.nn,
    EXTERNAL_SYSTEM_NAMES.tw,
];
